import { Container, Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAppInfo, getGateConf } from "../../store/app/selector";
import Cashout from "../cashout";
import GiftCode from "../giftcode";
import History from "../history";
import Reward from "../reward";
import Topup from "../topup";

import "./tab.scss"

export const GameTab = () => {

    const gateConf = useSelector(state => getGateConf(state))
    const { t } = useTranslation('translations');

    return (
        <Container className="home-tabs">
            {
                gateConf && <Tabs defaultActiveKey="topup" className="mb-3">

                    <Tab disabled={!gateConf.ci} eventKey="topup" title={t('txt3')}>
                        <Topup />
                    </Tab>
                    <Tab disabled={!gateConf.co} mountOnEnter eventKey="cashout" title={t('txt4')}>
                        <Cashout />
                    </Tab>
                    <Tab disabled={!gateConf.rw} mountOnEnter unmountOnExit={true}  eventKey="reward" title={t('txt66')}>
                        <Reward />
                    </Tab>

                    {/* <Tab disabled={!gateConf.hr}mountOnEnter  eventKey="history" title={t('txt7')}>
                        <History />
                    </Tab> */}

                    <Tab disabled={!gateConf.gc} mountOnEnter eventKey="giftcode" title={t('txt6')}>
                        <GiftCode />
                    </Tab>

                </Tabs>
            }

        </Container>
    )
}